@if (!isLoading() && co2Summary()) {
  <div class="blast-environment-container">
    <!-- Left column: Title + Chart -->
    <div class="left-column">
      <h3 class="section-title">{{ 'ENVIRONMENT.EMISSION_CO2' | translate }}</h3>
      <div class="co2-chart-section">
        <div class="donut-chart-container">
          <div class="donut-chart" [style.background]="getDonutGradient()">
            <div class="donut-hole">
              <span class="total-value">{{ co2Summary().total | number:'1.0-0' }} kg</span>
              <span class="total-label">{{ 'RECORD.TOTAL' | translate }}</span>
            </div>
          </div>
        </div>
        <div class="chart-legend">
          @for (category of co2Summary().categories; track category) {
            <div class="legend-item">
              <span class="legend-color" [style.background-color]="category.color"></span>
              <span class="legend-label">{{ category.translationKey | translate }}</span>
              <span class="legend-percentage">{{ category.percentage | number:'1.0-1' }}%</span>
            </div>
          }
        </div>
      </div>
    </div>
    <!-- Right column: Data tables (scrollable) -->
    <div class="co2-data-section">
      <!-- Transport -->
      <div class="data-card">
        <h4 class="card-title">{{ 'ENVIRONMENT.TRANSPORT' | translate }}</h4>
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ 'ENVIRONMENT.FACTORY' | translate }}</th>
              <th>{{ 'ENVIRONMENT.STORAGE' | translate }}</th>
              <th>{{ 'ENVIRONMENT.FACTORY_STORAGE' | translate }}</th>
              <th>{{ 'ENVIRONMENT.STORAGE_SITE' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ co2Summary().transport.factoryName }}</td>
              <td>{{ co2Summary().transport.storageName }}</td>
              <td>{{ co2Summary().transport.factoryToStorage | number:'1.0-0' }}</td>
              <td>{{ co2Summary().transport.storageToSite | number:'1.0-0' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Drilling -->
      <div class="data-card">
        <h4 class="card-title">{{ 'ENVIRONMENT.DRILLING' | translate }}</h4>
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ 'ENVIRONMENT.DRILL_TYPE' | translate }}</th>
              <th>{{ 'ENVIRONMENT.DRILLED_METERS' | translate }}</th>
              <th>{{ 'ENVIRONMENT.CO2_PER_METER' | translate }}</th>
              <th>{{ 'ENVIRONMENT.TOTAL_CO2' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (drill of co2Summary().drilling; track drill) {
              <tr>
                <td>{{ drill.drillType }}</td>
                <td>{{ drill.drilledMeters | number:'1.0-0' }}</td>
                <td>{{ drill.co2PerUnit | number:'1.0-0' }}</td>
                <td>{{ drill.total | number:'1.0-0' }}</td>
              </tr>
            }
            @if (co2Summary().drilling.length === 0) {
              <tr>
                <td colspan="4" class="empty-row">-</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <!-- Detonation -->
      <div class="data-card">
        <h4 class="card-title">{{ 'ENVIRONMENT.DETONATION' | translate }}</h4>
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ 'ENVIRONMENT.PRODUCT_NAME' | translate }}</th>
              <th>{{ 'ENVIRONMENT.QUANTITY' | translate }}</th>
              <th>{{ 'ENVIRONMENT.CO2_PER_UNIT' | translate }}</th>
              <th>{{ 'ENVIRONMENT.TOTAL_CO2' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (detonation of co2Summary().detonations; track detonation) {
              <tr>
                <td>{{ detonation.productName }}</td>
                <td>{{ detonation.quantity | number:'1.0-0' }}{{ detonation.isBulk ? ' (kg)' : '' }}</td>
                <td>{{ detonation.co2PerUnit | number:'1.0-0' }}</td>
                <td>{{ detonation.total | number:'1.0-0' }}</td>
              </tr>
            }
            @if (co2Summary().detonations.length === 0) {
              <tr>
                <td colspan="4" class="empty-row">-</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <!-- Product -->
      <div class="data-card">
        <h4 class="card-title">{{ 'ENVIRONMENT.PRODUCTION' | translate }}</h4>
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ 'ENVIRONMENT.PRODUCT_NAME' | translate }}</th>
              <th>{{ 'ENVIRONMENT.QUANTITY' | translate }}</th>
              <th>{{ 'ENVIRONMENT.CO2_PER_UNIT' | translate }}</th>
              <th>{{ 'ENVIRONMENT.TOTAL_CO2' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (product of co2Summary().products; track product) {
              <tr>
                <td>{{ product.productName }}</td>
                <td>{{ product.quantity | number:'1.0-0' }}{{ product.isBulk ? ' (kg)' : '' }}</td>
                <td>{{ product.co2PerUnit | number:'1.0-0' }}</td>
                <td>{{ product.total | number:'1.0-0' }}</td>
              </tr>
            }
            @if (co2Summary().products.length === 0) {
              <tr>
                <td colspan="4" class="empty-row">-</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}

<!-- Loading state -->
@if (isLoading()) {
  <div class="loading-container">
    <i class="fas fa-spinner fa-spin"></i>
    <span>{{ 'GLOBAL.CHARGEMENT' | translate }}...</span>
  </div>
}

<!-- Empty state -->
@if (!isLoading() && !co2Summary()) {
  <div class="empty-container">
    <p>{{ 'ENVIRONMENT.NO_DATA' | translate }}</p>
  </div>
}
